// extracted by mini-css-extract-plugin
export default {"padlockContainer":"Padlock_padlockContainer__piJgP","txt":"Padlock_txt__kWFbQ","disabled":"Padlock_disabled__zj+gM","iconName":"Padlock_iconName__rShKj","icon":"Padlock_icon__NF32G"};